<template>
  <div id="about" class="container" v-if="this.ppadmin_data">
    <div class="logo">
      <img
        loading="lazy"
        :src="viewDevice == 'mobile' ? aboutInfo.logoMobile : aboutInfo.logoWeb"
        alt="關於我們"
      />
    </div>
    <div class="intro">
      <template v-for="(item, key, index) in aboutInfo">
        <div
          class="box"
          :key="index"
          v-if="key != 'logoWeb' && key != 'logoMobile'"
        >
          <div class="left">
            <h3>{{ item.title }}</h3>
            <h4>{{ item.subtitle }}</h4>
            <p v-html="item.content"></p>
          </div>
          <div class="right">
            <img v-lazy="item.logo" :alt="item.title" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import windowSize from "@/mixins/windowSize";
import { mapState } from "vuex";
export default {
  name: "AboutView",
  computed: {
    ...mapState("headerNav", ["ppadmin_data"]),
    aboutInfo() {
      return this.ppadmin_data[4].data;
    },
  },
  mixins: [windowSize],
};
</script>

<style lang="less" scoped>
#about {
  padding: 0.4em 5em;
  .mobile({
    padding: 0.1em;
  });
  img {
    width: 100%;
    height: 100%;
  }
  .intro {
    .box {
      margin: 5em 0 0;

      .flex-mixin(row,space-between,center);
      .mobile({
        .flex-mixin(column,space-around,center);
        flex-direction: column-reverse;
      });
      .left,
      .right {
        flex: 1;
        text-align: left;
        padding: 0 1.5em;
      }
      .left {
        line-height: 2em;
      }
      &:nth-child(2),
      &:nth-child(4) {
        flex-direction: row-reverse;
        .mobile({
          flex-direction: column-reverse;
        });
      }

      h3 {
        color: #f09966;
        line-height: 2.8em;
      }
      h4 {
        line-height: 2.5em;
      }
      h4,
      p {
        color: @primary-color;
      }
    }
  }
}
</style>
